"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const Integration_1 = require("../../Integration");
const moment_timezone_1 = tslib_1.__importDefault(require("moment-timezone"));
let ActiveCampaignInput = class ActiveCampaignInput extends Integration_1.IntegrationInput {
    constructor() {
        super(...arguments);
        this.integrationTimezone = null;
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    class_validator_1.IsUrl({
        host_whitelist: [/[a-z0-0]+?\.activehosted\.com/],
        protocols: ['https'],
        require_protocol: true,
        require_valid_protocol: true,
    }, {
        message: () => {
            return 'URL does not match the expected pattern for ActiveCampaign URLs (e.g. https://examplecompany.activehosted.com)';
        },
    }),
    tslib_1.__metadata("design:type", Object)
], ActiveCampaignInput.prototype, "activeCampaignWorkspaceUrl", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    class_validator_1.IsUrl({
        host_whitelist: [/api-[a-z0-9]+?\.com/],
        protocols: ['https'],
        require_protocol: true,
        require_valid_protocol: true,
    }, {
        message: () => {
            return 'URL does not match the expected pattern for ActiveCampaign API URLs (e.g. https://examplecompany.api-us1.com)';
        },
    }),
    tslib_1.__metadata("design:type", Object)
], ActiveCampaignInput.prototype, "activeCampaignApiUrl", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    tslib_1.__metadata("design:type", Object)
], ActiveCampaignInput.prototype, "apiSecretKey", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    class_validator_1.IsOptional(),
    class_validator_1.IsIn(moment_timezone_1.default.tz.names()),
    tslib_1.__metadata("design:type", Object)
], ActiveCampaignInput.prototype, "integrationTimezone", void 0);
ActiveCampaignInput = tslib_1.__decorate([
    type_graphql_1.InputType()
], ActiveCampaignInput);
exports.ActiveCampaignInput = ActiveCampaignInput;
//# sourceMappingURL=index.js.map